import React from 'react';
import { Document } from '../../../interfaces/customer-api';
import css from './StockEquipmentDocuments.module.scss';
import BookIcon from '../../assets/book-icon.svg';
import { toTitleCase } from '../../utils';

export interface DocumentSectionProps {
    title: string;
    docs: Document[];
    displayName?: string;
}

export const DocumentSection: React.FC<DocumentSectionProps> = ({ title, docs, displayName }) => (
    <div className={css.document}>
        <BookIcon />
        <h4>{title}</h4>
        <div>
            {docs.length === 1 ? (
                <a className={css.documentName} key={docs[0].key} target="_blank" rel="noopener noreferrer" href={docs[0].url}>
                    {displayName ? toTitleCase(displayName) : toTitleCase(docs[0].type)}
                </a>
            ) : (
                docs.map((doc, index) => (
                    <a className={css.documentName} key={doc.key} target="_blank" rel="noopener noreferrer" href={doc.url}>
                        {displayName ? `${toTitleCase(displayName)}-${index + 1}` : `${toTitleCase(doc.type)}-${index + 1}`}
                    </a>
                ))
            )}
        </div>
    </div>
);
